import { UserInteractionServiceV22Impl, } from "./v2/user-interaction-service-v2";
export function defineUserInteractionService(options) {
    return {
        id: "user-interaction-service",
        dependencies: { featureServices: { "s2:history": "^3.0.0" } },
        optionalDependencies: { featureServices: { "s2:logger": "^1.0.0" } },
        create: (env) => {
            const { "s2:logger": logger = console, "s2:history": historyService } = env.featureServices;
            const userInteractionServicev2 = new UserInteractionServiceV22Impl(logger, historyService, options);
            const serviceV2 = createFeatureServiceV2(userInteractionServicev2);
            const serviceV1 = createFeatureServiceV1(userInteractionServicev2);
            return {
                "2.2.0": serviceV2,
                "1.1.0": serviceV1,
            };
        },
    };
}
function createFeatureServiceV2(userInteractionServicev2) {
    return () => ({
        featureService: {
            register(id, options) {
                return userInteractionServicev2.registerV2(id, options);
            },
            unregister(id) {
                userInteractionServicev2.unregister(id);
            },
            createNavigator(id, consumerId) {
                return userInteractionServicev2.createNavigator(id, consumerId);
            },
            getNavigatorConsumerId() {
                return userInteractionServicev2.getNavigatorConsumerId();
            },
            getActions() {
                return userInteractionServicev2.getActions();
            },
            get(id) {
                return userInteractionServicev2.getV2(id);
            },
        },
    });
}
function createFeatureServiceV1(userInteractionServicev2) {
    return () => ({
        featureService: {
            register(id, options) {
                return userInteractionServicev2.register(id, options);
            },
            get(id) {
                return userInteractionServicev2.get(id);
            },
            unregister(id) {
                userInteractionServicev2.unregister(id);
            },
            getActions() {
                return userInteractionServicev2.getActions();
            },
        },
    });
}
//# sourceMappingURL=user-interaction-service.js.map